export default __webpack_public_path__ + "static/brain-67ba325c7ec40ba860fa726a12a3dfcc.gif";